module.exports = __webpack_public_path__ + "static/media/panosta-svg-250x100.33daf5aa.svg";